//===============================================================================
// © 2017 Lifestyle Apps.  All rights reserved.
// Original Author: Sanjeev Khanna
// Original Date: 10 June 2017
//==============================================================================

/**
 * This class provide common helper methods like Get default values of  IANA timezone,Region,RegionLanguage,Lattitude,Longitude.
 */
export class CommonHelper {

    // /**
    //  * Get default value of IANA Time Zone Id.
    //  */
    // public static getIANATimeZoneId(): string {
    //     return "America/Los_Angeles";
    // }

    // private static regionLanguage: string = "";

    // /**
    //  * Get default value of region.
    //  */
    // public static getRegion(): string {
    //     // return "IN";
    //     if (CommonHelper.regionLanguage == "") {
    //         CommonHelper.regionLanguage = CommonHelper.getLocale().split("-", 2)[1];
    //     }
    //     // return "en";
    //     return CommonHelper.regionLanguage;
    // }

    // private static region: string = "";
    // /**
    //  * Get default value of Region Language.
    //  */
    // public static getRegionLanguage(): string {
    //     if (this.region == "") {
    //         CommonHelper.region = CommonHelper.getLocale().split("-", 1)[0];
    //     }
    //     // return "en";
    //     return CommonHelper.region;
    // }

    // /**
    //  * Get user/app culture (i.e. either Language or Language-Region).
    //  */
    // public static getLocale(): string {
    //     // let culture: string = this.getRegionLanguage();
    //     // if (this.getRegion() != "") {
    //     //     culture += "-" + this.getRegion();
    //     // }
    //     // return culture;
    //     return "en-US";
    // }

    // /**
    //  * Get default value of Latitude.
    //  */
    // public static getLatitude(): number {
    //     return 544;
    // }

    // /**
    //  * Get default value of Logitude.
    //  */
    // public static getLongitude(): number {
    //     return 352;
    // }

    public static isEmpty(value: any) {
        if (value == null || value == 'undefined' || value == '')
            return true;
        else
            return false;
    }

    /**
    * Convert string to date
    * @param value Convert string to Date
    */
    public static convertStringToDate(value: string): Date {
        let date: Date
        date = new Date('1900-01-01T00:00:00');

        if (!this.isNull(value)) {
            if (isNaN(Date.parse(value)) == false) {
                date = new Date(value);
            }
        }
        return date;
    }

    /**
     * String to date with format
     * @param _date 
     * @param _format 
     * @param _delimiter 
     */
    public static stringToDate(_date, _format, _delimiter) {
        var formatLowerCase = _format.toLowerCase();
        var formatItems = formatLowerCase.split(_delimiter);
        var dateItems = _date.split(_delimiter);
        var monthIndex = formatItems.indexOf("mm");
        var dayIndex = formatItems.indexOf("dd");
        var yearIndex = formatItems.indexOf("yyyy");
        var month = parseInt(dateItems[monthIndex]);
        month -= 1;
        var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
        return formatedDate;
    }


    /**
     * Converts string to number
     * @param value 
     */
    public static convertStringToNumber(value: string): Number {
        let num: Number;
        num = 0
        if (!this.isNull(value)) {
            if (isNaN(Number(value)) == false)
                return Number(value);
        }
        return num;
    }

    /**
     * Convert string to boolean.
     */
    public static convertStringToBoolean(value: string): boolean {
        let bool: boolean;
        bool = false

        if (!this.isNull(value)) {
            bool = (value.toLowerCase() == 'true') || (value.toLowerCase() == '1');
        }
        return bool;
    }

    /**
     * 
     * @param value Check validity of given value
     */
    public static isNull(value: any): boolean {
        if (value == '' || value == 'undefined' || value == null)
            return true;
        else
            return false
    }

    // Enum  Operations

    /**
     * Convert string to specified enum
     * @param value 
     */
    public static stringToEnum<T>(value: string): T {
        var k: T;
        //var options : string[] = Object.keys(( typeof T)); 
        var v: T = (k)["offline"];
        var val: T;
        val = val[value]
        return val;
    }

    /**
     * Convert enum to string
     * @param value 
     */
    public static enumToString<T>(value: T): string {

        var a: T
        var str = value.toString();
        var p = (a)[str];
        return (<T>value)[value.toString()]
    }

    // /**
    //  * Convert status enum value to string
    //  * @param value 
    //  */
    // public static statusEnumToString(value: StatusEnum): string {
    //     return StatusEnum[value];
    // }

    // /**
    //  * Convert string to status enum
    //  * @param value 
    //  */
    // public static statusStringToEnum<StatusEnum>(value: string): StatusEnum {
    //     var val: StatusEnum = StatusEnum[value]
    //     return val;
    // }

    /**
     * Validate Email
     */
    public static validateEmail(emailID): boolean {

        let atpos = emailID.indexOf("@");
        let dotpos = emailID.lastIndexOf(".");
        if (atpos < 1 || (dotpos - atpos < 2)) {
            return false;
        }
        return (true);
    }
    /**
  * Convert enum to string
  * @param value 
  */
    public static enumToStringNew(enumVal: any, value: any): string {
        return enumVal[value.toString()]
    }
   
    /**
    * check isGuid
    * @param stringToTest 
    */
    static isGuid(stringToTest) {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        return regexGuid.test(stringToTest);
    }

    static getBrowserLanguage(): string {
         let locale:string = window.navigator.language;
        if (CommonHelper.isEmpty(locale)){
             locale= "en"
        }
        else {
            locale = locale.split('-')[0];
        }
        return locale;
    }


    //Method use in order to Generate Guid. Can be moved to Helper Class
    public static GenrateNewGuid() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now();; //use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }


}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/helpers/common.helper.ts